<template>
  <div id="content" class="pc">
    <Menu></Menu>
<!--    <router-view :key="key"></router-view>-->
    <Main></Main>
    <HelpBoard></HelpBoard>
    <DataListBoard></DataListBoard>
    <MapLocationBoard></MapLocationBoard>
    <DataBoard></DataBoard>
    <MapSetting ref="mapSetting" />
  </div>
</template>

<script>
import Menu from '@/layout/web/components/Menu'
import HelpBoard from '@/components/HelpBoard'
import DataListBoard from '@/components/DataListBoard'
import DataBoard from '@/components/DataBoard'
import MapLocationBoard from '@/components/MapLocationBoard'
import MapSetting from '@/views/web/MapSetting'
import Main from '@/views/web/Main'

export default {
  name: 'Contents',
  components: {
    Menu,
    HelpBoard,
    DataListBoard,
    DataBoard,
    MapLocationBoard,
    MapSetting,
    Main
  },
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style scoped>

</style>
